import { useCallback } from 'react';
import { useAppSelector } from 'src/hooks/hooks';
import { Behaviors, EnumBehaviorKey } from 'src/types/Behaviors';

/** 判断是否有某个行为 */
export const hasBehavior = (
  behaviors: Behaviors.DataItem[],
  behaviorKey: EnumBehaviorKey,
) => {
  return behaviors.some(behavior => behavior.key === behaviorKey);
};

/** 判断是否有多个行为 */
export const hasBehaviors = (
  behaviors: Behaviors.DataItem[],
  behaviorKeys: EnumBehaviorKey[],
) => {
  return behaviorKeys.every(behaviorKey => hasBehavior(behaviors, behaviorKey));
};

/** 判断是否有任意一个行为 */
export const hasOneBehavior = (
  behaviors: Behaviors.DataItem[],
  behaviorKeys: EnumBehaviorKey[],
) => {
  return behaviorKeys.some(behaviorKey => hasBehavior(behaviors, behaviorKey));
};

export const useBehavior = () => {
  const { behaviors, behaviorKeys } = useAppSelector(
    state => state.behaviorReducer,
  );
  /** 判断是否有某个行为 */
  const newHasBehavior = useCallback(
    (behaviorKey: EnumBehaviorKey | EnumBehaviorKey[]) => {
      if (Array.isArray(behaviorKey)) {
        return hasBehaviors(behaviors, behaviorKey);
      }
      return hasBehavior(behaviors, behaviorKey);
    },
    [behaviors],
  );
  /** 判断是否有任意一个行为 */
  const newHasOneBehavior = useCallback(
    (behaviorKey: EnumBehaviorKey[]) => {
      return hasOneBehavior(behaviors, behaviorKey);
    },
    [behaviors],
  );
  return {
    behaviorKeys,
    behaviors,
    /** 判断是否有某个行为 */
    hasBehavior: newHasBehavior,
    /** 判断是否有任意一个行为 */
    hasOneBehavior: newHasOneBehavior,
  };
};
